module.exports = __webpack_public_path__ + "img/touqian.47403d3f.png";